import { Navigate, Outlet, useLocation, useSearchParams } from "react-router";
import { useAuth } from "./AuthProvider";
import { loginPath, safeRedirect } from "./redirect";
import { NotFoundPage } from "@/features/misc/NotFoundPage";

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();
  if (status !== "authed") return <Navigate to={loginPath(location.pathname + location.search)} replace />;
  return <Outlet />;
}

export function RequireAdmin() {
  const { status, user } = useAuth();
  const location = useLocation();
  if (status !== "authed") return <Navigate to={loginPath(location.pathname + location.search)} replace />;
  // Non-admins get a 404, mirroring the API (never reveal admin routes).
  if (user?.role !== "admin") return <NotFoundPage />;
  return <Outlet />;
}

export function RedirectIfAuthed() {
  const { status } = useAuth();
  const [params] = useSearchParams();
  if (status === "authed") return <Navigate to={safeRedirect(params.get("redirect"))} replace />;
  return <Outlet />;
}

export function HomeRedirect() {
  const { status } = useAuth();
  return <Navigate to={status === "authed" ? "/situs" : "/masuk"} replace />;
}
